import { useReactToFullscreenPopups } from './useReactToFullscreenPopups';
import { useSetupExtensionCommunication } from './useSetupExtensionCommunication';

export const SupportParentInfinity = () => {
  useSetupExtensionCommunication();
  useReactToFullscreenPopups();

  return null;
};
